module.exports = __webpack_public_path__ + "static/index-slider-02-bd2a26787728c083835c23c8a1658778.jpg";